export enum ProviderNames {
    ADAYA = 'Adaya',
    SHOPIFY = 'Shopify',
    FACEBOOK = 'Facebook',
    GOOGLE = 'Google',
    KLAVIYO = 'Klaviyo',
    TIKTOK = 'TikTok',
    AMAZON = 'Amazon'
}
